import { createFileRoute, redirect } from '@tanstack/react-router'
import { requireAuthenticated } from '@/shared/lib/route-guards'

export const Route = createFileRoute('/$lang/settings/')({
  beforeLoad: ({ context, params }) => {
    requireAuthenticated(context, params)
    throw redirect({
      to: '/$lang/settings/general',
      params: { lang: params.lang },
    })
  },
  staticData: { layout: 'main' },
})
